import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderSlot as _renderSlot, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-69393bfc"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "color-222"
};
const _hoisted_2 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("i", null, null, -1));
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_van_icon = _resolveComponent("van-icon");
  return _openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["nav-header flex items-center flex-justify-between", {
      'app-active': $setup.isapp
    }])
  }, [_createVNode(_component_van_icon, {
    size: "24px",
    name: "arrow-left",
    onClick: $setup.goBack
  }, null, 8, ["onClick"]), _createElementVNode("span", _hoisted_1, _toDisplayString($props.title), 1), _hoisted_2, _renderSlot(_ctx.$slots, "right", {
    class: "right"
  }, undefined, true)], 2);
}